// @flow
import React from 'react';

import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import { Video, type VideoProps } from 'Components/frameworks/video/Video.jsx';

type Props = {
  ...$Exact<VideoProps>,
  id?: string,
};

export function VideoLine({ id, ...props }: Props) {
  return (
    <SiteContainer id={id} className="Line">
      <Video {...props} />
    </SiteContainer>
  );
}
